module.exports = __webpack_public_path__ + "img/xm.008debc2.jpg";